export const SEARCH_OPENED = 'SEARCH_OPENED';
export const SEARCH_TEXT = 'SEARCH_TEXT';